"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyTextWidgetDesign = isEmptyTextWidgetDesign;
/** Returns true if the text widget design is empty. */
function isEmptyTextWidgetDesign(design) {
    return design == null || (design.items != null && design.items.length === 0);
}
